import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { useAppSelector } from 'core/store/hooks';
import useUserMetaData from 'hooks/useUserMetaData';
import GetProButton from '../../GetProButton';

const RightSide = () => {
  const isClaimLoading = useAppSelector((state) => state.claimsV2.isClaimLoading);
  const theme = useTheme();

  const isMobileScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  const { noOrTrialSubscription } = useUserMetaData();
  const hideGetProButton = !(isMobileScreen && isClaimLoading);

  return (
    <Stack direction={{ mobile: 'column', tablet: 'row' }} alignItems="center" spacing={1}>
      {noOrTrialSubscription && hideGetProButton && <GetProButton title="Get Pro" />}
    </Stack>
  );
};

export default RightSide;
